import { Page } from "@/components/layout/Page";
import { WidgetFrame } from "@/components/layout/WidgetFrame";
import { colSpan, height } from "@/components/widgets/widget.utils";
import { ActionListTableWidget } from "@/pages/DashboardPage/fms/widgets/ActionListTableWidget/ActionListTableWidget";

const ProactiveSupportSection = () => {
    return (
        <Page.Content.Section>
            <Page.Content.Section.Title>Proactive Support</Page.Content.Section.Title>
            <Page.Content.Widgets>
                <WidgetFrame colSpan={colSpan.tableFull} height={height.table}>
                    <ActionListTableWidget />
                </WidgetFrame>
            </Page.Content.Widgets>
        </Page.Content.Section>
    );
};

export { ProactiveSupportSection };
